import angular from 'angular';
import { containsFocus, DIRECTIVE_NAME } from './contains-focus.directive';

export const ContainsFocusModule = angular
  .module('app.directives.contains-focus', [])
  .directive(DIRECTIVE_NAME, containsFocus);
